/**
 * ENVIRONMENT: PRODUCTION
 * MODULE: Authentication API Request Handlers
 * PATH: src/requests/auth.js
 */

import api from 'utils/api';

// Step 1: Primary Authentication (User ID / Email + Password + Captcha)
export const login = (data) => {
  // data: { email, password, captcha_token }
  return api.post('/login', data);
};

// Check active session & permissions
export const getAuthUser = () => {
  return api.get('/auth-check');
};

// Step 2: Out-of-Band 2FA OTP Verification
export const verifyLoginOtp = (data) => {
  // data: { mobile, otp, email, temp_token }
  return api.post('/login-send-otp-verify', data);
};

// Resend OTP in Step 2 if expired
export const sendLoginOtp = (data) => {
  // data: { mobile, captcha_token }
  return api.post('/login-send-otp', data);
};

// Administrative Session Termination
export const logout = () => {
  return api.get('/admin/logout');
};